<template>
    <BaseInput
        v-model="value"
        :class="{ 'w-100': useMaxWidthInBaseInput }"
        :name="name"
        :required="required"
        :rules="rules"
        :autocomplete="autocomplete"
        :label="label"
        @input.stop>
        <template #label>
            <slot name="label" />
        </template>
        <el-select
            v-model="value"
            :value-on-clear="valueOnClear"
            style="min-width: 120px"
            v-bind="$attrs"
            :trigger-on-focus="false"
            :placeholder="placeholder">
            <slot />
        </el-select>
    </BaseInput>
</template>

<script setup>
import BaseTooltip from "../BaseTooltip.vue";

const props = defineProps({
    modelValue: {
        required: true
    },
    name: {
        type: String
    },
    label: {
        type: String
    },
    placeholder: {
        type: String
    },
    valueOnClear: {
        default: null
    },
    required: {
        type: Boolean,
        default: false
    },
    rules: {
        type: [Object, String],
        default: null
    },
    useMaxWidthInBaseInput: {
        type: Boolean,
        default: true
    },
    autocomplete: {
        type: String,
        default: ""
    }
})

const emits = defineEmits(['update:modelValue'])

const value = computed({
    get: () => props.modelValue,
    set: (val) => emits('update:modelValue', val)
})
</script>

<style lang="scss" scoped>
:deep(.el-form-item) {
    width: 100%;
}

:deep(.el-tag__close) {
    background-color: transparent;
    color: white;

    &:hover {
        background-color: transparent;
    }
}
</style>